import { Modal } from "reactstrap";
import styled from "styled-components";

const MetsecModal = styled(Modal)`
  > .modal-content {
    border-radius: 0 !important;

    > .modal-header {      
      background-color: #0082b4 !important;
      border-radius: 0 !important;

      > .modal-title {
        font-size: 1rem !important;
        color: #fff !important;

      }
    }
  }

  .close > span:nth-child(1) {
    color: white;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

export default MetsecModal;
